var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.829 8.3485L8.5066 14.4266L10.2117 18.4356C11.2458 20.8661 11.9551 22.4831 12.0127 22.5388C12.2235 22.7483 12.572 22.7581 12.789 22.5574C12.8791 22.4748 13.7661 20.4329 17.0733 12.6992C19.3672 7.33488 21.2569 2.88629 21.2753 2.81313C21.3159 2.67107 21.2797 2.45615 21.2045 2.33821C21.1591 2.27482 20.4297 2.96414 14.829 8.3485Z",
    fill: "#EEA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5397 8.01225L7.83612 13.5744L4.24386 11.2522C2.06609 9.84398 0.620221 8.88533 0.575125 8.81856C0.404521 8.5731 0.444348 8.21631 0.666876 8.02423C0.758577 7.94442 2.83596 7.33713 10.6968 5.09049C16.1493 3.53221 20.6693 2.25281 20.7418 2.24472C20.8833 2.22402 21.0837 2.29221 21.1859 2.38607C21.2401 2.44158 20.4781 3.08499 14.5397 8.01225Z",
    fill: "#FFD070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/planeIcon.af8fddd3.svg";
export { ForwardRef as ReactComponent };